import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.string.link";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2017,2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */


import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import IconSet from './IconSet';
import { uniqueIdForComponent } from '../util';
var buttonTypes = ['button', 'primary-button', 'secondary-button', 'success-button', 'danger-button', 'outline-button', 'icon-button', 'link-button'];
var linkTypes = ['default', 'visited', 'external', 'footer', 'active', 'skipNav'];

var Link = function Link(_ref) {
  var link = _ref.link,
      type = _ref.type,
      unStyled = _ref.unStyled,
      inverse = _ref.inverse,
      children = _ref.children,
      to = _ref.to,
      list = _ref.list,
      className = _ref.className,
      otherProps = _objectWithoutProperties(_ref, ["link", "type", "unStyled", "inverse", "children", "to", "list", "className"]);

  var addLinkStyle = !unStyled && buttonTypes.indexOf(type) === -1; // if type is not of button type or not unStyled

  var stylingClass = classNames(className, {
    'wds-c-link': addLinkStyle,
    'wds-u-current': type === 'active',
    'wds-c-footer-primary-link': type === 'footer',
    'wds-c-button': type === 'button',
    'wds-c-button wds-c-button--primary': type === 'primary-button',
    'wds-c-button wds-c-button--secondary': type === 'secondary-button',
    'wds-c-button wds-c-button--success': type === 'success-button',
    'wds-c-button wds-c-button--danger': type === 'danger-button',
    'wds-c-button wds-c-button--outline': type === 'outline-button',
    'wds-c-button wds-c-button--icon': type === 'icon-button',
    'wds-c-button wds-c-button--link': type === 'link-button',
    'wds-c-color-text-visited': type === 'visited',
    // TODO remove on next breaking change - doesn't do anything
    'wds-c-link--external': type === 'external',
    'wds-c-list__item': list,
    'wds-c-skipnav': type === 'skipNav',
    'wds-c-link--inverse': inverse
  });

  if (!to && !link) {
    console.error('Expected `to` or `link` to be supplied to the Link component');
  }

  return link ? React.cloneElement(link, Object.assign({
    className: stylingClass
  }, otherProps), [children, type === 'external' && React.createElement(IconSet, {
    key: uniqueIdForComponent(),
    decorative: true,
    name: "external-link",
    size: "small"
  })]) : React.createElement("a", _extends({
    href: to,
    className: stylingClass
  }, otherProps), children, type === 'external' && React.createElement(IconSet, {
    decorative: true,
    className: "wds-u-ml--x-small",
    name: "external-link",
    size: "small"
  }));
};

Link.propTypes = {
  /** additional styling */
  className: PropTypes.string,

  /** type of link:
   * 'default', 'visited', 'external',
   * 'button', 'primary-button', 'secondary-button', 'success-button', 'danger-button',
   * 'outline-button', 'icon-button', 'link-button',
   * 'footer', 'active', 'skipNav' */
  type: PropTypes.oneOf(linkTypes.concat(buttonTypes)),

  /** Remove default styling */
  unStyled: PropTypes.bool,

  /**
  child elements
  */
  children: PropTypes.node,

  /**
  indicates where the link will direct
  */
  to: PropTypes.string,

  /**
  passes a node to direct to e.g. React Router Link component
  */
  link: PropTypes.node,

  /**
   is the Link placed inside listgroup?
  */
  list: PropTypes.bool,

  /** inverse link, used on a dark background */
  inverse: PropTypes.bool
};
Link.defaultProps = {
  to: undefined,
  link: undefined,
  className: undefined,
  children: undefined,
  type: 'default',
  unStyled: false,
  list: false,
  inverse: false
};
export default Link;